export const IDENTITY_SDK_RESET_COOKIE = "identitySdkResetRequired";
export const GTM_PARENT = { id: "GTM-NR75XMD", endpoint: "iygafc" };
export const GTM_IFRAME = {
  id: "GTM-NKPNS83",
  endpoint: "fnudft"
};
export const AUTH_LAST_ACTION = {
  SIGNIN_EMAIL: 7,
  SIGNIN_SOCIAL: 6,
  SIGNUP_EMAIL: 2,
  SIGNUP_SOCIAL: 1,
  LINK_ACCOUNTS: 3
};
